import React, { Component } from 'react';
import {connect} from 'react-redux';
import {
    Switch,
    Route,
    Redirect
} from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import { Spin, Icon } from 'antd';
import Layout from './Layout';
import Sidebar from './Sidebar';
import Applications from './Applications';
import Landlords from './Landlords';
import Application from './Application';
import Landlord from './Landlord';
import Users from './Users';

class Index extends Component {
    renderRoutes({match}) {
        return (
            <Switch>
                <PrivateRoute requires="read admin users" path={`${match.url}/users`} component={Users} />
                <PrivateRoute requires="read applications" path={`${match.url}/applications/:id`} component={Application} />
                <PrivateRoute requires="read applications" path={`${match.url}/applications`} component={Applications} />
                <PrivateRoute requires="read landlords" path={`${match.url}/landlords/:id`} component={Landlord} />
                <PrivateRoute requires="read landlords" path={`${match.url}/landlords`} component={Landlords} />
                <PrivateRoute requires="read accounts" path={`${match.url}/accounts`} component={() => <span>Invoicing and Accounts</span>} />
            </Switch>
        );
    }
    renderLoading() {
        const icon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
        return <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            bottom: 0,
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0
        }}>
            <Spin size="large" tip="LOADING" indicator={icon}/>
        </div>;
    }
    render() {
        const {me: {isFetching}} = this.props;
        const renderSidebar = props => <Sidebar {...props}/>;

        return (
            <Layout renderSidebar={renderSidebar}>
                {isFetching ? this.renderLoading() : this.renderRoutes(this.props)}
            </Layout>
        );
    }
}

function mapStateToProps(state) {
    return {me: state.me, auth: state.auth};
}

export default connect(mapStateToProps)(Index);


// WEBPACK FOOTER //
// ./resources/assets/js/components/Index.js